module.exports = __webpack_public_path__ + "static/media/solutions__buyer_in_control.b632774e.png";